<template>
    <div class="tab-education">
        <div class="blockcont undergrad-school">
            <div class="smalltitle">Undergraduate/Graduate School</div>
            <ul class="itemlist">
                <li v-for="graduate in graduateSchool">
                    <div class="row">
                        <div class="col-xs-5">{{graduate.name}}</div>
                        <div class="col-xs-3"><em>{{graduate.stateCity}} {{graduate.countryOrName}}</em></div>
                        <div class="col-xs-2">{{graduate.years}}</div>
                        <div class="col-xs-2 itemaction">
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="blockcont medical-school">
            <div class="smalltitle"> Medical School</div>
            <ul class="itemlist">
                <li v-for="item in medicalSchool">
                    <div class="row">
                        <div class="col-xs-5">{{item.name}}</div>
                        <div class="col-xs-3"><em>{{item.stateCity}} {{item.countryOrName}}</em></div>
                        <div class="col-xs-2">{{item.years}}</div>
                        <div class="col-xs-2 itemaction">
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="blockcont residency">
            <div class="smalltitle">Residency</div>
            <ul class="itemlist">
                <li v-for="item in residencyData">
                    <div class="row">
                        <div class="col-xs-3">{{item.name}}</div>
                        <div class="col-xs-3">{{item.countryOrName}}</div>
                        <div class="col-xs-2">{{item.stateCity}}</div>
                        <div class="col-xs-2">{{item.years}}</div>
                        <div class="col-xs-2 itemaction">

                        </div>
                    </div>
                </li>

            </ul>
        </div>

        <div class="blockcont fellowship">
            <div class="smalltitle">Fellowship</div>
            <ul class="itemlist">
                <li v-for="item in fellowshipData">
                    <div class="row">
                        <div class="col-xs-3">{{item.name}}</div>
                        <div class="col-xs-3">{{item.countryOrName}}</div>
                        <div class="col-xs-2">{{item.stateCity}}</div>
                        <div class="col-xs-2">{{item.years}}</div>
                        <div class="col-xs-2 itemaction">
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="blockcont board-cer">
            <div class="smalltitle">Board Certification</div>
            <ul class="itemlist">
                <li v-for="item in boardCertificationData">
                    <div class="row">
                        <div class="col-xs-8">{{item.name}}</div>
                        <div class="col-xs-2">{{item.years}}</div>
                        <div class="col-xs-2 itemaction"></div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import CommonMixin from './../../../../mixins/general/CommonMixin.vue'
import config from '../../../../config'
import httpClient from '../../../../client'

export default {
  name: 'TabAccountSetting',
  components: {},
  props: {
    userInfo: {}
  },
  mixins: [CommonMixin],
  data () {
    return {
      graduateSchool: [],
      medicalSchool: [],
      residencyData: [],
      fellowshipData: [],
      boardCertificationData: []
    }
  },
  computed: {
    disabledForm () {
      return true
    }
  },
  watch: {},
  updated () {
  },
  mounted () {
    this.getEducation()
  },
  beforeDestroy () {
  },
  methods: {
    async getEducation () {
      try {
        let response = await httpClient.get('/users/education/' + this.userInfo.id)
        if (response.data.s === 200) {
          let educations = response.data.data.educations
          if (educations) {
            this.graduateSchool = educations.filter(item => item.kind === 'undergraduate')
            if (this.graduateSchool.length) {
              this.graduateSchool.sort((a, b) => a.indexKey - b.indexKey)
            }
            this.medicalSchool = educations.filter(item => item.kind === 'medical')
            if (this.medicalSchool.length) {
              this.medicalSchool.sort((a, b) => a.indexKey - b.indexKey)
            }
            this.residencyData = educations.filter(item => item.kind === 'residency')
            if (this.residencyData.length) {
              this.residencyData.sort((a, b) => a.indexKey - b.indexKey)
            }
            this.fellowshipData = educations.filter(item => item.kind === 'fellowship')
            if (this.fellowshipData.length) {
              this.fellowshipData.sort((a, b) => a.indexKey - b.indexKey)
            }
            this.boardCertificationData = educations.filter(item => item.kind === 'certification')
            if (this.boardCertificationData.length) {
              this.boardCertificationData.sort((a, b) => a.indexKey - b.indexKey)
            }
          }
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    }
  }
}
</script>
<style scoped="">

</style>
